// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Ht0H","left":"StickyBox_left__TSrej","right":"StickyBox_right__ywR1t"};